import { LocalizationManager } from "../../localization/localization_manager.js";
import { PURCHASE_FAILURE_TEXT_KEYS, purchaseFailureKind } from "../../offers/purchase_failure.js";
import { UIElement } from "../common_ui_elements/ui_element.js";
import { AnchoredTooltip } from "./anchored_tooltip.js";

const PURCHASE_TOOLTIP_OWNER = "purchase";

export function showPurchaseFailedTooltip( anchor: UIElement, error: unknown ): boolean
{
  const kind = purchaseFailureKind( error );
  if ( kind === "silent" ) return false;
  AnchoredTooltip.show( anchor, { text: LocalizationManager.t( PURCHASE_FAILURE_TEXT_KEYS[kind] ) }, PURCHASE_TOOLTIP_OWNER );
  return true;
}

export function hidePurchaseFailedTooltip(): void
{
  AnchoredTooltip.hide( PURCHASE_TOOLTIP_OWNER );
}
